import { Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { InfoCard2 } from '../../widgets/components/UI/InfoCard2'
import { useState } from 'react'
import Copy from '../../../../media/images/shareModal/copy.svg'
import '../style/AIGeneratedReplies.scss'
import { toast } from 'react-toastify'
import { ToolTipUIForModal } from '../../widgets/components/UI/ToolTipUIForModal'
import { Quill } from '../../widgets/components/Input/Quill'
import brandingConfig from '../../../../config/brandingConfig'
// import RectangularTabs from '../../widgets/components/RectangularTabs'

export default function WriteWithAI({
  isActive,
  setIsActive,
  handleIsActive,
  setAiEmailResponse,
  aiEmails,
  GenerateEmailByAi,
  aiPrompt,
  setAiPrompt,
  isAiEmailGenerating,
}: any) {
  const { formatMessage } = useIntl()
  const [quillText, setQuillText] = useState('')

  const [tab, setTab] = useState(1)

  // const cleanEmailText = (text: string): string => {
  //   // Step 1: Remove the ```html and any ``` tags
  //   let cleanedText = text?.replace(/```html/g, '').replace(/```/g, '');

  //   // Step 2: Remove any <h1> tags and their content, including surrounding spaces or newlines
  //   cleanedText = cleanedText?.replace(/\s*<h1[^>]*>.*?<\/h1>\s*/g, '');

  //   // Step 3: Remove <meta>, <title>, and other head elements, including surrounding spaces or newlines
  //   cleanedText = cleanedText?.replace(/\s*<head[\s\S]*?<\/head>\s*/g, '');

  //   // Step 4: Remove the doctype and <html> tags, including surrounding spaces or newlines
  //   cleanedText = cleanedText?.replace(/\s*<!DOCTYPE[^>]*>\s*/g, '').replace(/\s*<\/?html[^>]*>\s*/g, '');

  //   // Step 5: Remove <body> tags, but keep the content within
  //   cleanedText = cleanedText?.replace(/\s*<\/?body[^>]*>\s*/g, '');

  //   // Step 6: Optionally trim any leading or trailing whitespace
  //   cleanedText = cleanedText?.trim();

  //   return cleanedText;
  // };

  const cleanEmailText = (text: string): string => {
    // Step 1: Remove the ```html and any ``` tags
    let cleanedText = text?.replace(/```html/g, '').replace(/```/g, '')

    // Step 2: Remove any <h1> tags and their content
    cleanedText = cleanedText?.replace(/<h1[^>]*>.*?<\/h1>/g, '')

    // Step 3: Remove <meta>, <title>, and other head elements if present
    cleanedText = cleanedText?.replace(/<head[\s\S]*?<\/head>/g, '')

    // Step 4: Remove the doctype and <html> tags
    cleanedText = cleanedText?.replace(/<!DOCTYPE[^>]*>/g, '').replace(/<\/?html[^>]*>/g, '')

    // Step 5: Remove <body> tags, but keep the content within
    cleanedText = cleanedText?.replace(/<\/?body[^>]*>/g, '')
    cleanedText = cleanedText?.replace(/<\/?div[^>]*>/g, '')

    cleanedText = cleanedText?.trim()
    // Step 6: Remove everything after the last square bracket []
    // cleanedText = cleanedText?.replace(/\[.*?\]\s*<br>[^]*$/, '')

    return cleanedText
  }

  return (
    <>
      <Modal
        show={isActive}
        onHide={() => {
          setIsActive(false)
        }}
        size='lg'
      >
        <Modal.Header closeButton>
          <h2>{formatMessage({ id: 'Generate using AI' })}</h2>
        </Modal.Header>
        <Modal.Body>
          <InfoCard2
            title='AI-Generated Email Drafts'
            desc='Write a prompt describing your requirements, and receive multiple AI-generated email drafts tailored to your needs. Choose the one that resonates best to save time and ensure effective communication.'
            slug={brandingConfig.helpLinks.sharedAccessAiGeneratedEmail}
          />

          <div className='d-flex flex-column row'>
            <label className='textarea-label mb-1 d-flex'>
              {formatMessage({ id: 'Enter Prompt' })}
              <ToolTipUIForModal
                tooltipText={formatMessage({
                  id: 'Enter the prompt for the AI, this will control the AI response.',
                })}
              />
            </label>
            <div className='d-flex flex-row justify-content-between'>
              <div className='col-10 d-flex'>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Enter Prompt'
                  value={aiPrompt}
                  onChange={(e) => setAiPrompt(e.target.value)}
                />
              </div>
              <div className='d-flex flex-end ms-2'>
                <button
                  type='button'
                  className='btn btn-primary fw-normal'
                  onClick={GenerateEmailByAi}
                  disabled={isAiEmailGenerating}
                >
                  {isAiEmailGenerating ? 'Generating...' : 'Generate'}
                </button>
              </div>
            </div>
          </div>
          <div className='row gap-3 p-3'>
            {/* {options.map((opt, index) => (
              <div
                key={opt.id}
                className={
                  `col options-container px-4 py-5 align-content-center cursor-pointer` +
                  (tab === index + 1 ? ' selected-option' : '')
                }
                onClick={() => setTab(index + 1)}
              >
                <h1>{opt.title}</h1>
                <p>{opt.subTitle}</p>
              </div>
              // <RectangularTabs
              //   key={opt.id}
              //   title={opt.title}
              //   subTitle={opt.subTitle}
              //   onClick={() => setTab(index + 1)}
              // />
            ))} */}
            {aiEmails &&
              aiEmails.map((opt: any, index: number) => (
                <div
                  key={opt.id}
                  className={
                    `col options-container px-4 py-5 align-content-center cursor-pointer` +
                    (tab === index + 1 ? ' selected-option' : '')
                  }
                  onClick={() => {
                    setTab(index + 1)
                    setQuillText(cleanEmailText(aiEmails[tab - 1]))
                  }}
                >
                  <h1>Option {index + 1}</h1>
                  <p>{aiPrompt}</p>
                </div>
                // <RectangularTabs
                //   key={opt.id}
                //   title={opt.title}
                //   subTitle={opt.subTitle}
                //   onClick={() => setTab(index + 1)}
                // />
              ))}
          </div>
          <div className='d-flex flex-column'>
            <div className='d-flex justify-content-between align-items-center mb-2'>
              <label className='textarea-label d-flex'>
                {formatMessage({ id: 'AI Generated Respose' })}
                <ToolTipUIForModal
                  tooltipText={formatMessage({
                    id: 'These are the AI Generated responses based on the given prompt.',
                  })}
                />
              </label>
              <div className='d-flex flex-row'>
                <div
                  className='border border-mute p-1 rounded ms-2 cursor-pointer'
                  onClick={() => {
                    navigator.clipboard.writeText(`${quillText}`)
                    toast.success(formatMessage({ id: 'Copied Successfully' }))
                  }}
                >
                  <img src={Copy} alt='' />
                </div>
              </div>
            </div>
            {/* <InboxQuill quillText={quillText} setQuillText={setQuillText} aiEmailResponse={cleanEmailText(aiEmails[tab - 1])}/> */}
            <Quill
              quillText={quillText}
              setQuillText={setQuillText}
              aiEmailResponse={cleanEmailText(aiEmails[tab - 1])}
            />
            {/* <textarea
              rows={15}
              // cols={100}
              className='px-4 py-2 overflow-hidden'
              disabled
              name=''
              id=''
              value={aiEmails[tab - 1]}
            ></textarea> */}
          </div>
        </Modal.Body>
        <Modal.Footer className='p-0'>
          <div className='d-flex gap-3 m-5 justify-content-end'>
            <button
              type='button'
              className='btn btn-bg-light fw-normal font-size-13'
              style={{ padding: '15px 40px' }}
              onClick={handleIsActive}
            >
              {formatMessage({ id: 'Close' })}
            </button>
            <button
              type='button'
              className='btn btn-primary fw-normal font-size-13 me-2 '
              style={{ padding: '15px 40px' }}
              onClick={() => {
                setAiEmailResponse(quillText)
                handleIsActive()
              }}
            >
              <span className='indicator-label font-size-13 p-0'>
                {formatMessage({ id: 'Insert' })}
              </span>
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}
